import axios from 'axios';
import type { NavigateFunction } from 'react-router';

import { isServerRenderedPath, resolveSafeReturnTo } from '../../utils/resolveReturnTo';

export const navigateToReturnTo = (navigate: NavigateFunction, returnTo: unknown): void => {
  const safeReturnTo = resolveSafeReturnTo(returnTo);

  if (isServerRenderedPath(safeReturnTo)) {
    window.location.replace(safeReturnTo);
    return;
  }

  navigate(safeReturnTo, { replace: true });
};

const isSessionRefreshed = async (signal: AbortSignal): Promise<boolean> => {
  try {
    const response = await axios.get<{ result?: boolean }>('/api/refresh_auth_token', { signal });
    const isSuccessStatus = response.status >= 200 && response.status < 300;
    return isSuccessStatus && response.data?.result === true;
  } catch {
    return false;
  }
};

export const resumeSessionAtReturnTo = async (
  navigate: NavigateFunction,
  returnTo: unknown,
  signal: AbortSignal,
): Promise<{ isResumed: boolean }> => {
  const safeReturnTo = resolveSafeReturnTo(returnTo);

  if (!isServerRenderedPath(safeReturnTo)) {
    navigate(safeReturnTo, { replace: true });
    return { isResumed: true };
  }

  if (!(await isSessionRefreshed(signal)) || signal.aborted) {
    return { isResumed: false };
  }
  window.location.replace(safeReturnTo);
  return { isResumed: true };
};
